/** RESPONSIBILITY: expected failures as values, not exceptions. */

export type Result<T, E = string> =
  | { ok: true; value: T }
  | { ok: false; error: E };

export const Ok = <T>(value: T): Result<T, never> => ({ ok: true, value });
export const Err = <E>(error: E): Result<never, E> => ({ ok: false, error });

export const isOk = <T, E>(r: Result<T, E>): r is { ok: true; value: T } => r.ok;

/** Unwrap or fall back. Never throws. */
export const orElse = <T, E>(r: Result<T, E>, fallback: T): T => (r.ok ? r.value : fallback);
